import { render, staticRenderFns } from "./StaffShowTable.vue?vue&type=template&id=9d808b6a&scoped=true&"
import script from "./StaffShowTable.vue?vue&type=script&lang=js&"
export * from "./StaffShowTable.vue?vue&type=script&lang=js&"
import style0 from "./StaffShowTable.vue?vue&type=style&index=0&id=9d808b6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d808b6a",
  null
  
)

export default component.exports